// @flow

import type {ApiSuccess} from '@travel-frontend/state-handling-sdk';
import type {AsyncAction} from 'redux/types';
import type {SepaPutRequest} from 'redux/v1/paymentTravel/sepa/put/model';

import {ASYNC_TYPES} from '@travel-frontend/state-handling-sdk';
import axios from 'axios';

import {config as cfg} from 'config';

export const PUT_PAYMENT_SEPA = 'v1/paymentInsurance/PUT_PAYMENT_SEPA';

export type PutSepaSuccess = ApiSuccess<[], *>;

export const putInsuranceSepa = (
  journeyId: number,
  token: string,
  data: SepaPutRequest
): AsyncAction => {
  const config = {
    headers: {Authorization: `Bearer ${token}`},
  };

  return {
    types: ASYNC_TYPES(PUT_PAYMENT_SEPA),
    callAPI: () =>
      axios
        .put(
          `${cfg.bookingServiceUrl}/insurance/payment/sepa/${journeyId}`,
          data,
          config
        )
        .then((_) => {}),
  };
};
